module.exports = __webpack_public_path__ + "static/media/stealth-optional.74b03446.png";